import { Paper, Typography, Box } from "@mui/material";
import { Container } from "@mui/system";

const Oferta = () => {
  return (
    <Container maxWidth='xl'>
      <Paper elevation={6}>
        <Typography
          variant='h4'
          paddingTop={5}>
          ДОГОВОР ПУБЛИЧНОЙ ОФЕРТЫ
        </Typography>

        <Box sx={{ padding: 5 }}>
          <Typography
            align='justify'
            paragraph
            variant='p'>
            г. Екатеринбург
          </Typography>
          <Typography
            align='justify'
            paragraph>
            <strong>1. Общие положения</strong>
          </Typography>
          <Typography
            align='justify'
            paragraph>
            1.1 Данный документ является официальным предложением (публичной
            офертой) ИП Деменев Денис Владимирович (ОГРНИП 323665800189356 от
            13.09.2023 ИНН 665812336008), именуемого в дальнейшем Исполнитель, и
            содержит все существенные условия предоставления услуг любому
            физическому или юридическому лицу, именуемого в дальнейшем Заказчик.
            <Typography
              align='justify'
              paragraph>
              1.2 В соответствии с пунктом 2 статьи 437 Гражданского Кодекса
              Российской Федерации (ГК РФ) в случае совершения действий по
              выполнению указанных в ней условий договора (в частности, оплата
              услуг) считается акцептом оферты. При этом договор считается
              заключенным без подписания в каждом конкретном случае, так как
              акцепт оферты приравнивается к заключению договора на указанных
              ниже условиях.
            </Typography>
            <Typography
              align='justify'
              paragraph>
              1.3 Акцептом (принятием) условий, изложенных в настоящей оферте,
              является факт полной оплаты услуг Исполнителя по выставленному
              Исполнителем счету. В соответствии с п.3 ст.438 ГК РФ, акцепт
              настоящей Оферты равносилен заключению договора в письменной
              форме.
            </Typography>
            <Typography
              align='justify'
              paragraph>
              1.4 Исполнитель и Заказчик, именуемые в дальнейшем Стороны,
              действуют согласно данному публичному договору-оферте о
              предоставлении рекламных услуг, именуемый в дальнейшем Договор.
            </Typography>
          </Typography>
          <Typography
            align='justify'
            paragraph>
            <strong> 2. Предмет оферты.</strong>
          </Typography>
          <Typography
            align='justify'
            paragraph>
            2.1 Согласно договору-оферте, Исполнитель предоставляет Заказчику
            услуги, связанные с размещением рекламных материалов Заказчика в
            сети Интернет на сайте https://social-max.ru/ в выбранных Заказчиком
            сообществах на условиях, установленных данным Договором.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            2.2 Заказчик обязуется оплатить услуги в сроки и в порядке,
            определенными настоящим Договором в п.6.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            <strong>3. Порядок исполнения договора</strong>
          </Typography>
          <Typography
            align='justify'
            paragraph>
            3.1 Заказчик предоставляет Исполнителю всю информацию, необходимую
            для оказания услуг, и осуществляет предоставление рекламных
            материалов, размещаемых согласно настоящему Договору.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            3.2 В течение одного рабочего дня с момента предоставления
            Заказчиком рекламных материалов. Исполнитель обязуется принимать
            решение о размещении рекламных материалов Заказчика либо об отказе
            от размещения. Решение Исполнителя об отказе от размещения может
            быть принято по любым основаниям, указанным в п.4 настоящего
            Договора, которые Исполнитель сочтет существенными в каждом
            конкретном случае. Решение Исполнителя об отказе от размещения
            доводится до сведения Заказчика любым возможным способом в день его
            принятия.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            3.3 При исполнении настоящего Договора Заказчику предоставляется
            возможность ознакомления с данными статистики рекламной кампании,
            посредством скриншотов сделанных публикаций.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            3.4 Исполнитель вправе, в целях исполнения настоящего Договора,
            заключать договоры с третьими лицами.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            <strong>4. Требования к рекламным материалам</strong>
          </Typography>
          <Typography
            align='justify'
            paragraph>
            4.1. Предоставляемые Заказчиком рекламные материалы должны
            соответствовать нормам и требованиям действующего законодательства
            РФ, и «Требованиям к рекламным материалам» Исполнителя, размещенным
            и/или доступным в сети Интернет. Исполнитель оставляет за собой
            право отклонить любые предоставленные Заказчиком рекламные
            материалы, а также приостановить размещение рекламных материалов в
            случаях, если их размещение и/или содержание, и/или форма
            противоречат указанным в Договоре требованиям, либо не соответствуют
            рекламной политике Исполнителя.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            4.2. Заказчик гарантирует, что содержание и форма рекламных
            материалов, определение и использование ключевых слов, размещение
            Исполнителем рекламных материалов в соответствии с определенными
            Исполнителем условиями размещения не нарушает и не влечет за собой
            нарушение каких-либо прав третьих лиц и действующего
            законодательства РФ в том числе, но, не ограничиваясь Федеральным
            Законом «О рекламе» и его дополнениями
            (https://www.consultant.ru/document/cons_doc_LAW_58968/).
          </Typography>
          <Typography
            align='justify'
            paragraph>
            4.3. Требования к рекламным материалам, публикуемым в сети
            ВКонтакте, описаны по адресу: https://vk.com/terms.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            <strong>5. Маркировка рекламных материалов</strong>
          </Typography>
          <Typography
            align='justify'
            paragraph>
            5.1. В соответствии с новыми требованиями рекламного
            законодательства, рекламные материалы, публикуемые в социальных
            сетях, должны быть промаркированы. Исполнитель является
            Рекламораспространителем и берет на себя обязанности по маркировке
            рекламных материалов, в рамках настоящего договора. То есть,
            исполнитель обязуется передать сведения о себе и рекламодателе
            оператору рекламных данных (далее – ОРД), зарегистрировать рекламные
            креативы в Едином Реестре Интернет Рекламы (далее – ЕРИР), получить
            идентификаторы рекламных креативов, а также, передать прочую
            информацию в ОРД, в соответствии с требованиями закона «О рекламе».
          </Typography>
          <Typography
            align='justify'
            paragraph>
            5.2. Заказчик является Рекламодателем. Если Заказчик является
            посредником между другим Рекламодателем и Рекламораспространителем,
            он обязан об этом сообщить Исполнителю, а также передать все
            необходимые данные изначального рекламодателя и изначального
            рекламного договора между рекламодателем и первым посредником, для
            внесения их в ОРД и передачи ЕРИР.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            5.3. Исполнитель, как Рекламораспространитель, не несет
            ответственности за действия других участников рекламной цепочки
          </Typography>
          <Typography
            align='justify'
            paragraph>
            <strong>6. Цена и порядок расчетов</strong>
          </Typography>
          <Typography
            align='justify'
            paragraph>
            6.1. Размещение рекламных материалов Заказчика осуществляется при
            условии полной предоплаты.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            6.2. Стоимость размещения рекламно-информационных материалов, в
            рамках настоящего договора, определяется расчетными документами
            (счетами, выставляемыми Исполнителем в адрес заказчика). Объемы и
            виды публикаций указываются в выставляемых счетах.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            6.3. Заказчик обязан своевременно, и в полном объеме перечислять
            Исполнителю денежные средства, согласно счетам, необходимые для
            выполнения настоящего договора. При этом факсимильные или
            электронные копии счетов, направленные Заказчику, считаются
            полученными и подлежащими оплате в течение трёх банковских дней.
            Оригиналы счетов, после отправки их по факсу или электронной почтой
            могут передаваться Заказчику вместе с Актами об оказанных услугах с
            курьером и/или почтовой доставкой, по завершению рекламных кампаний.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            6.4. Оплата производится путем перечисления денежных средств на
            расчетный счет Исполнителя. При безналичных расчетах днем оплаты
            является день получения денежных средств на расчетный счет
            Исполнителя. Оплата производится в рублях на основании выставленного
            счета.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            6.5. Исполнитель вправе не размещать рекламные материалы Заказчика
            до момента поступления денежных средств в полном объеме.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            6.6. Исполнитель имеет право изменять цены, виды и объемы
            предоставляемых Исполнителем услуг. В случаях, когда изменения имеют
            существенное значение для исполнения Исполнителем своих обязательств
            по настоящему Договору, Исполнитель обязуется предварительно
            уведомлять Заказчика о таких изменениях, не позднее, чем за семь
            календарных дней до вступления в силу данных изменений.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            6.7. Цены и объемы предоставляемых Исполнителем услуг не подлежат
            изменению: по ранее оплаченным Заказчиком счетам; по счетам, ранее
            выставленным Заказчику, за исключением счетов, оплата которых
            просрочена.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            6.8. По окончании каждого отчетного периода, но не позднее семи дней
            после него. Исполнитель предоставляет Заказчику Акт об оказанных
            услугах. В течение трёх рабочих дней с момента предоставления Акта
            об оказанных услугах Заказчик обязан принять его или письменно
            сообщить Исполнителю о возражениях по Акту об оказанных услугах. По
            истечении указанного срока, Акт об оказанных услугах считается
            принятым Заказчиком в полном объеме без претензий.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            6.9. Стороны согласились, что в спорных ситуациях достаточным
            подтверждением объема и стоимости, оказанных по настоящему Договору
            Услуг, являются данные статистики опубликованных материалов.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            <strong>7. Ответственность и ограничение ответственности</strong>
          </Typography>
          <Typography
            align='justify'
            paragraph>
            7.1. За нарушение условий настоящего Договора Стороны несут
            ответственность, предусмотренную законодательством РФ и настоящим
            Договором.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            7.2. Исполнитель не несет ответственности по настоящему Договору:
          </Typography>
          <Typography
            align='justify'
            paragraph>
            7.2.1. за какие-либо косвенные/непрямые убытки и/или упущенную
            выгоду Заказчика вне зависимости от того, мог ли Исполнитель
            предвидеть возможность причинения таких убытков в конкретной
            ситуации или нет;
          </Typography>
          <Typography
            align='justify'
            paragraph>
            7.2.2. за какую-либо часть работ/услуг, требуемых для реализации
            настоящего Договора, выполняемых Заказчиком без предусмотренной
            ответственности и/или контроля Исполнителя, а также за какой-либо
            ущерб, явившийся следствием действия или бездействия, или нарушения
            настоящего Договора Заказчиком.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            7.3. Совокупная ответственность Исполнителя в отношении оказания
            услуг по размещению рекламных материалов, в том числе по настоящему
            Договору, ограничивается 50% от стоимости услуг Исполнителя по
            соответствующему счету.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            7.4. Заказчик самостоятельно в полном объеме несет ответственность
            за соответствие содержания и формы рекламных материалов требованиям
            законодательства, юридическую правомерность использования логотипов,
            фирменных наименований и прочих объектов интеллектуальной
            собственности и средств индивидуализации в рекламных материалах, в
            т.ч. в перечне ключевых слов, а равно за отсутствие в материалах
            обязательной информации, предусмотренной законодательством РФ.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            7.5. В случае если размещение материалов по настоящему Договору
            явилось основанием для предъявления к Исполнителю претензий, исков
            и/или предписаний по уплате штрафных санкций со стороны
            государственных органов и/или третьих лиц. Заказчик обязуется
            незамедлительно по требованию Исполнителя предоставить ему всю
            запрашиваемую информацию, касающуюся размещения и содержания
            материалов, содействовать Исполнителю в урегулировании таких
            претензий и исков, а также возместить все убытки (включая судебные
            расходы, расходы по уплате штрафов), причиненные Исполнителю
            вследствие предъявления ему таких претензий, исков, предписаний в
            связи с нарушением прав третьих лиц и/или действующего
            законодательства РФ в результате размещения материалов.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            7.6. За нарушение Заказчиком сроков оплаты, указанных в п.6 и
            Приложении 1, настоящего Договора, Исполнитель вправе взыскать с
            Заказчика пени в размере 0,1% от стоимости размещения
            рекламно-информационных материалов за каждый день просрочки.
            Заказчик обязан уплатить пени в случае предъявления письменного
            (электронного, факсимильного, доставленного курьером или почтовой
            доставкой) требования Исполнителя.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            <strong>8. Форс-Мажор</strong>
          </Typography>
          <Typography
            align='justify'
            paragraph>
            8.1. Стороны освобождаются от ответственности за частичное или
            полное неисполнение обязательств по настоящему Договору, если это
            неисполнение явилось следствием обстоятельств непреодолимой силы,
            которые возникли после заключения настоящего Договора, либо если
            неисполнение обязательств Сторонами по настоящему Договору явилось
            следствием событий чрезвычайного характера, которые Стороны не могли
            ни предвидеть, ни предотвратить разумными мерами.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            8.2. К обстоятельствам непреодолимой силы относятся события, на
            которые Сторона не может оказывать влияния и за возникновение
            которых она не несет ответственности, как то: война, восстание,
            забастовка, землетрясение, наводнение, пожар, суровые погодные
            условия или подобные явления, правительственные постановления,
            распоряжения (указы) государственных органов (Президента РФ), законы
            и иные нормативные акты компетентных органов, принятые после
            подписания настоящего Договора и делающие невозможным исполнение
            обязательств, установленных настоящим Договором, а также действия
            государственных или муниципальных органов и их представителей,
            препятствующих выполнению условий Договора, и другие непредвиденные
            обстоятельства, в том числе неполадки городской электросети, но не
            ограничиваясь указанным.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            8.3. Сторона, ссылающаяся на обстоятельства непреодолимой силы,
            обязана информировать другую Сторону о наступлении и характере
            подобных обстоятельств в письменной форме с приложением копий
            соответствующих документов.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            8.4. В случае возникновения обстоятельств непреодолимой силы срок
            выполнения обязательств по настоящему Договору отодвигается
            соразмерно времени, в течение которого действуют такие
            обстоятельства и их последствия.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            <strong>9. Заключительные положения</strong>
          </Typography>
          <Typography
            align='justify'
            paragraph>
            9.1. Настоящий Договор и его исполнение регулируется в соответствии
            с законодательством Российской Федерации.
          </Typography>
          <Typography
            align='justify'
            paragraph>
            9.2. Все споры и разногласия между Сторонами по настоящему Договору,
            в связи с настоящим Договором и/или его исполнением Стороны будут
            стремиться урегулировать путем переговоров. Если в результате
            переговоров Стороны не достигли взаимоприемлемого решения, спор
            подлежит разрешению в Арбитражном суде города Екатеринбурга.
          </Typography>
        </Box>
        <Box sx={{ padding: 5 }}>
          <Typography
            align='justify'
            paragraph>
            <strong>Реквизиты</strong>
          </Typography>
          <Typography
            align='justify'
            paragraph>
            ИП Деменев Денис Владимирович
          </Typography>
          <Typography
            align='justify'
            paragraph>
            Юр. адрес: 620043 г.Екатеринбург, пос. Чусовское озеро, ул.Зеленая,
            45
          </Typography>
          <Typography
            align='justify'
            paragraph>
            Телефон: +79956772697
          </Typography>
          <Typography
            align='justify'
            paragraph>
            ИНН: 665812336008
          </Typography>
          <Typography
            align='justify'
            paragraph>
            ОГРНИП: 323665800189356
          </Typography>
          <Typography
            align='justify'
            paragraph>
            Расч. счет: 40802810400005220323
          </Typography>
          <Typography
            align='justify'
            paragraph>
            Банк: АО "ТИНЬКОФФ БАНК"
          </Typography>
          <Typography
            align='justify'
            paragraph>
            Кор. счет: 30101810145250000974
          </Typography>
          <Typography
            align='justify'
            paragraph>
            БИК: 044525974
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default Oferta;
